import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/loan/circle_add.svg';
const _withScopeId = n => (_pushScopeId("data-v-444ad691"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-wrap"
};
const _hoisted_2 = {
  class: "content flex-row-space-between"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "input-loan"
};
const _hoisted_5 = {
  class: "loan-amount-wrap flex-row-items-center"
};
const _hoisted_6 = {
  class: "token-select"
};
const _hoisted_7 = {
  class: "bottom-amount-tip"
};
const _hoisted_8 = {
  key: 0,
  class: "tip error"
};
const _hoisted_9 = {
  key: 1,
  class: "tip"
};
const _hoisted_10 = {
  class: "tip-txt"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "vip-amount-icon"
}, null, -1));
const _hoisted_12 = {
  class: "input-pledge"
};
const _hoisted_13 = {
  class: "pledge-amount-wrap flex-row-items-center"
};
const _hoisted_14 = {
  class: "token-select"
};
const _hoisted_15 = {
  class: "bottom-amount-tip"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  key: 2,
  class: "tip error"
};
const _hoisted_19 = {
  key: 3,
  class: "tip ar-sa"
};
const _hoisted_20 = {
  class: "tip-txt"
};
const _hoisted_21 = {
  key: 4,
  class: "pledge-asset-btn-group"
};
const _hoisted_22 = {
  class: "loan-el-button"
};
const _hoisted_23 = {
  class: "right"
};
const _hoisted_24 = {
  class: "right-container"
};
const _hoisted_25 = {
  class: "right-tit-box"
};
const _hoisted_26 = {
  class: "init-ltv-title"
};
const _hoisted_27 = {
  class: "total-info"
};
const _hoisted_28 = {
  class: "title flex-row"
};
const _hoisted_29 = {
  key: 1,
  class: "value"
};
const _hoisted_30 = {
  class: "title flex-row"
};
const _hoisted_31 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_32 = {
  class: "hours-amount-tips"
};
const _hoisted_33 = {
  key: 0,
  class: "vip-discount"
};
const _hoisted_34 = {
  key: 0,
  class: "num-txt"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "liner"
}, "/", -1));
const _hoisted_36 = {
  class: "data-txt"
};
const _hoisted_37 = {
  class: "title flex-row red-box"
};
const _hoisted_38 = {
  class: "liquidation-price"
};
const _hoisted_39 = {
  class: "value red"
};
const _hoisted_40 = {
  class: "value"
};
const _hoisted_41 = {
  class: "pledge-rate"
};
const _hoisted_42 = {
  class: "title flex-row"
};
const _hoisted_43 = {
  class: "common"
};
const _hoisted_44 = {
  class: "tooltip-text"
};
const _hoisted_45 = {
  class: "flex-row flex-items-center common-value"
};
const _hoisted_46 = {
  class: "value init"
};
const _hoisted_47 = {
  class: "common"
};
const _hoisted_48 = {
  class: "tooltip-text"
};
const _hoisted_49 = {
  class: "flex-row flex-items-center common-value"
};
const _hoisted_50 = {
  class: "value warning"
};
const _hoisted_51 = {
  class: "common"
};
const _hoisted_52 = {
  class: "tooltip-text"
};
const _hoisted_53 = {
  class: "flex-row flex-items-center common-value"
};
const _hoisted_54 = {
  class: "value liquidate"
};
const _hoisted_55 = {
  class: "flex-items-center flex-row-space-between"
};
const _hoisted_56 = ["href"];
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon iconfont sfe-icon-right"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_account_select = _resolveComponent("account-select");
  const _component_token_select = _resolveComponent("token-select");
  const _component_sfe_input = _resolveComponent("sfe-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_process = _resolveComponent("process");
  const _component_kyc_dialog = _resolveComponent("kyc-dialog");
  const _component_loan_dialog = _resolveComponent("loan-dialog");
  const _component_vip_dialog = _resolveComponent("vip-dialog");
  const _component_fundpool_unavailable = _resolveComponent("fundpool-unavailable");
  const _directive_precision = _resolveDirective("precision");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h4", null, [_createTextVNode(_toDisplayString($setup.t('loan_want')) + " ", 1), _createVNode(_component_account_select, {
    "pledge-account": _ctx.loanAccount,
    onChange: _ctx.changeLoanAccount
  }, null, 8, ["pledge-account", "onChange"])]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_sfe_input, {
    modelValue: $setup.loanamount,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.loanamount = $event),
    id: "loan-input-amount",
    placeholder: $setup.t('loan_input_amount'),
    "data-precision": $setup.loanPrecision(_ctx.loanToken),
    "data-precision-key": "loanamount",
    "data-precision-max": $setup.remainLoanAmount.num,
    onInput: _ctx.inputLoanAmount,
    class: _normalizeClass(["flex-1", {
      'error': _ctx.isLoanAmountTip
    }])
  }, {
    append: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_token_select, {
      token: _ctx.loanToken,
      data: $setup.loanEnabledTokens,
      "delete-token": _ctx.pledgeToken,
      onChange: _ctx.changeLoanToken,
      disabled: _ctx.loanSelectDisabled
    }, null, 8, ["token", "data", "delete-token", "onChange", "disabled"])])]),
    _: 1
  }, 8, ["modelValue", "placeholder", "data-precision", "data-precision-max", "onInput", "class"])), [[_directive_precision]])]), _createElementVNode("div", _hoisted_7, [_ctx.isLoanAmountTip ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.loanAmountTip), 1)) : _createCommentVNode("", true), !_ctx.isLoanAmountTip ? (_openBlock(), _createElementBlock("p", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString($setup.t('remainingLimit')) + ": " + _toDisplayString($setup.remainLoanAmount.num) + " " + _toDisplayString(_ctx.loanToken) + " | " + _toDisplayString($setup.remainLoanAmount.rate) + "% ", 1), _createElementVNode("span", {
    class: "get-amount",
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.changeVipDialogVisible && _ctx.changeVipDialogVisible(...args))
  }, [_createTextVNode(" ( " + _toDisplayString($setup.t('getHightLoanAmount')) + " ", 1), _hoisted_11, _createTextVNode(" ) ")])])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
    class: "icon icon-swap-arrow",
    onClick: _cache[2] || (_cache[2] = (...args) => _ctx.switchLoanPledge && _ctx.switchLoanPledge(...args))
  }), _createElementVNode("div", _hoisted_12, [_createElementVNode("h4", null, [_createTextVNode(_toDisplayString($setup.t('loan_pledge_amount')) + " ", 1), _createVNode(_component_account_select, {
    "pledge-account": _ctx.pledgeAccount,
    onChange: _ctx.changePledgeAccount
  }, null, 8, ["pledge-account", "onChange"])]), _createElementVNode("div", _hoisted_13, [_withDirectives((_openBlock(), _createBlock(_component_sfe_input, {
    modelValue: $setup.pledgeamount,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.pledgeamount = $event),
    id: "pledge-input-amount",
    placeholder: $setup.t('loan_input_pledge_amount'),
    "data-precision": $setup.pledgePrecision(_ctx.pledgeToken),
    "data-precision-key": "pledgeamount",
    "data-precision-max": $setup.remainPledgeAmount.num,
    onInput: _ctx.inputPledgeAmount,
    class: _normalizeClass(["flex-1", {
      'error': _ctx.isPledgeAmountTip || _ctx.isAssetAmountTip
    }])
  }, {
    append: _withCtx(() => [_createElementVNode("span", {
      class: _normalizeClass({
        'max': true,
        'grayed-out': $setup.isDisabled
      }),
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.setMaxPledge && _ctx.setMaxPledge(...args))
    }, _toDisplayString($setup.t('max')), 3), _createElementVNode("div", _hoisted_14, [_createVNode(_component_token_select, {
      token: _ctx.pledgeToken,
      data: $setup.pledgeEnabledTokens,
      "delete-token": _ctx.loanToken,
      onChange: _ctx.changePledgeToken
    }, null, 8, ["token", "data", "delete-token", "onChange"])])]),
    _: 1
  }, 8, ["modelValue", "placeholder", "data-precision", "data-precision-max", "onInput", "class"])), [[_directive_precision]])]), _createElementVNode("div", _hoisted_15, [_ctx.isAssetAmountTip ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    class: "tip assets-tip ar-sa error",
    onClick: _cache[5] || (_cache[5] = (...args) => _ctx.handleAssets && _ctx.handleAssets(...args)),
    innerHTML: _ctx.pledgeAssetTip
  }, null, 8, _hoisted_16)) : _ctx.isPledgeAmountTip ? (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: "tip error",
    innerHTML: _ctx.pledgeAmountTip
  }, null, 8, _hoisted_17)) : $setup.currentLtv.isAbove ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString($setup.t('ltvExceedInitial', {
    num1: $setup.usePledgeRate.initialLtv
  })), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString($setup.t('remainingCollateralLimit')) + ": " + _toDisplayString($setup.remainPledgeAmount.num) + " " + _toDisplayString(_ctx.pledgeToken) + " | " + _toDisplayString($setup.remainPledgeAmount.rate) + "% ", 1)])), !_ctx.isAssetAmountTip ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createTextVNode(_toDisplayString($setup.t('balance')) + ":  " + _toDisplayString($setup.toFormatToken(_ctx.transferBalance, _ctx.pledgeToken)) + " " + _toDisplayString(_ctx.pledgeToken) + " ", 1), _createElementVNode("img", {
    class: "add-icon",
    onClick: _cache[6] || (_cache[6] = (...args) => _ctx.handleAssets && _ctx.handleAssets(...args)),
    src: _imports_0,
    alt: "transfer",
    id: "transfer"
  })])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
    class: "confirm",
    type: "main",
    loading: _ctx.confirmLoading,
    disabled: !$setup.btnDisabled,
    onClick: _ctx.confirmLoan
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.btnText), 1)]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("h3", _hoisted_26, _toDisplayString($setup.t('earnSummary')), 1), _createElementVNode("div", {
    class: "vip-icon",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.changeVipDialogVisible(true))
  }, _toDisplayString($setup.t('vipLoan')), 1)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", null, _toDisplayString($setup.t('ltvAfterBorrowing')), 1), $setup.currentLtv.num ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(`value ${$setup.currentLtv.isAbove ? 'liquidate' : 'init'}`)
  }, _toDisplayString($setup.currentLtv.num) + "% ", 3)) : (_openBlock(), _createElementBlock("span", _hoisted_29, " - "))]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_el_tooltip, {
    effect: "dark",
    content: $setup.t('hoursAmountTips', {
      amount: '0.00000001',
      coin: 'USDT'
    }),
    placement: "top",
    teleported: false
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_32, _toDisplayString($setup.t('HourlyAnnualizedInterestRate')), 1)]),
    _: 1
  }, 8, ["content"]), $setup.isVIP ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString($setup.t('vipLowerInterestRate')), 1)) : _createCommentVNode("", true)]), $setup.limitData?.[0] ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("span", null, _toDisplayString($setup.truncateDecimal($setup.interestRateMap?.[$setup.limitData?.[0]]?.hour, 8)) + "%", 1), _hoisted_35, _createElementVNode("span", _hoisted_36, _toDisplayString($setup.truncateDecimal($setup.interestRateMap?.[$setup.limitData?.[0]]?.year, 2)) + " %", 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("span", null, _toDisplayString($setup.t('LiquidationPrice')), 1), _createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(Number(_ctx.qiangpingPrice) !== 0 ? $setup.toFormatInterest(_ctx.qiangpingPrice, _ctx.loanToken, 0) : '-') + " " + _toDisplayString(_ctx.pledgeToken) + "/" + _toDisplayString(_ctx.loanTokenName), 1), _createElementVNode("span", _hoisted_40, [_createElementVNode("i", null, "(" + _toDisplayString(Number(_ctx.qiangpingPrice) !== 0 ? $setup.toFormatInterest(1 / _ctx.qiangpingPrice, _ctx.loanToken, 0) : '-'), 1), _createElementVNode("i", null, _toDisplayString(_ctx.loanTokenName) + "/" + _toDisplayString(_ctx.pledgeToken) + ")", 1)])])])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_tooltip, {
    effect: "dark",
    placement: "top",
    teleported: false,
    content: $setup.t('loan_init_ltv_tip')
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_44, _toDisplayString($setup.t('loan_init_ltv')), 1)]),
    _: 1
  }, 8, ["content"]), _createElementVNode("p", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString($setup.usePledgeRate.initialLtv) + "%", 1)])]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_el_tooltip, {
    effect: "dark",
    placement: "top",
    teleported: false,
    content: $setup.t('loan_warning_ltv_tip')
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_48, _toDisplayString($setup.t('marginCallLtvRat')), 1)]),
    _: 1
  }, 8, ["content"]), _createElementVNode("p", _hoisted_49, [_createElementVNode("span", _hoisted_50, _toDisplayString($setup.usePledgeRate.marginCall) + "%", 1)])]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_el_tooltip, {
    effect: "dark",
    placement: "top",
    teleported: false,
    content: $setup.t('loan_liquidate_ltv_tip')
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_52, _toDisplayString($setup.t('loan_liquidate_ltv')), 1)]),
    _: 1
  }, 8, ["content"]), _createElementVNode("p", _hoisted_53, [_createElementVNode("span", _hoisted_54, _toDisplayString($setup.usePledgeRate.liquidationLtv) + "%", 1)])])])]), _createElementVNode("div", _hoisted_55, [_createElementVNode("span", null, _toDisplayString($setup.t('fixedRateTerm')), 1), _createElementVNode("a", {
    class: "fixed-loan-entry",
    href: $setup.replace('/trade/spot/fixed-loan'),
    target: "_blank"
  }, [_createTextVNode(_toDisplayString($setup.t('fixedRateLoan')) + " ", 1), _hoisted_57], 8, _hoisted_56)])])])]), _createVNode(_component_process), _createVNode(_component_kyc_dialog, {
    visible: $setup.checkUser.visible,
    "onUpdate:visible": _cache[8] || (_cache[8] = $event => $setup.checkUser.visible = $event),
    content: $setup.checkUser.content,
    type: $setup.checkUser.type,
    "confirm-text": $setup.checkUser.confirmText
  }, null, 8, ["visible", "content", "type", "confirm-text"]), _createVNode(_component_loan_dialog, {
    visible: _ctx.loanDialogVisible,
    "onUpdate:visible": _cache[9] || (_cache[9] = $event => _ctx.loanDialogVisible = $event),
    data: _ctx.loanDialogData,
    onSuccess: _ctx.handleSuccess
  }, null, 8, ["visible", "data", "onSuccess"]), _createVNode(_component_vip_dialog, {
    visible: _ctx.vipDialogVisible,
    "onUpdate:visible": _cache[10] || (_cache[10] = $event => _ctx.vipDialogVisible = $event),
    token: _ctx.loanToken,
    data: $setup.loanEnabledTokens,
    onClose: _cache[11] || (_cache[11] = $event => _ctx.changeVipDialogVisible(false)),
    onSuccess: _ctx.handleVip
  }, null, 8, ["visible", "token", "data", "onSuccess"]), _createVNode(_component_fundpool_unavailable, {
    content: _ctx.fundPoolUnavailableText,
    "onUpdate:content": _cache[12] || (_cache[12] = $event => _ctx.fundPoolUnavailableText = $event)
  }, null, 8, ["content"])]);
}